import { createContext } from 'react';
import { Api } from './APIClient';

export type APIContextType = {
    api: Api;
};

export const APIContext = createContext<APIContextType | null>(null);
